import { v4 as uuidv4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';

export function addInSubscribedSchedules({ subscription, schedule }) {
    this.subscriptions = this.subscriptions.map((item) => {
        if (isEmpty(item.subscribedSchedules)) item.subscribedSchedules = [];
        if (item.id === subscription.id) {
            item.subscribedSchedules = [...item.subscribedSchedules, schedule];
        }
        return item;
    });

    // Keep connectedSchedules map in sync — it's the derived snapshot used by the UI
    this.connectedSchedules[subscription.id] = [
        ...(this.connectedSchedules[subscription.id] || []),
        schedule,
    ];

    this.observed.subscriptions = uuidv4();
}
